import { Network } from 'turbos-clmm-sdk';
import production, { type Config } from './mainnet';

const staging: Config = {
  ...production,
  sui_network: Network.testnet,
  api_url: 'https://api.parrot.finance/dev',
  explorer_url: {
    suiscan: {
      txb: 'https://suiscan.xyz/testnet/tx/{{txb}}',
      account: 'https://suiscan.xyz/testnet/account/{{account}}',
      object: 'https://suiscan.xyz/testnet/object/{{object}}',
      coin: 'https://suiscan.xyz/testnet/coin/{{coin}}',
    },
    suivision: {
      txb: 'https://testnet.suivision.xyz/txblock/{{txb}}',
      account: 'https://testnet.suivision.xyz/account/{{account}}',
      object: 'https://testnet.suivision.xyz/object/{{object}}',
      coin: 'https://testnet.suivision.xyz/coin/{{coin}}',
    },
  },
  fullnode: 'https://fullnode.testnet.sui.io:443',
};

export default staging;
